import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";
import { PostApi } from './../index';

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.TRADE_SERVER_PREFIX}/fiber`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: Number) => `${RESOURCE_ENDPOINT}/${id}`,
    bulk: () => `${RESOURCE_ENDPOINT}/bulk`,
    bulkStore: () => `${RESOURCE_ENDPOINT}/bulk-store`,
    getLastPosts: () => `${RESOURCE_ENDPOINT}/get-last-posts`,
    review: () => `${RESOURCE_ENDPOINT}/review`,
    reviewInfo: () => `${RESOURCE_ENDPOINT}/review/info`,
}

export default class FiberApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }
    public review = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.review();
        return HttpService.post(url, payload, params, headers);
    }
    public reviewInfo = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.reviewInfo();
        return HttpService.get(url, params, headers);
    }

    public getLastPosts = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLastPosts();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public deletePost = async (id:any) => {
        console.log('rabbidelete', id)
        const post = await this.getById(id)
        if(post?.data?.post_id) {
            console.log('rabbidelete', post?.data?.post_id)
           await PostApi.delete(post?.data?.post_id)
        }
    }
    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        this.deletePost(id)
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public bulk = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulk();
        return HttpService.post(url, payload, params, headers);
    }

    public bulkStore = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.bulkStore();
        return HttpService.post(url, payload, params, headers);
    }
}